import React from 'react';
import { Row, Col, Form, Radio, Input, Button, Tag, Checkbox } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface QuizChoice {
  id: string;
  choices: string[];
  answer: number | number[];
}

interface QuizChoiceSectionProps {
  quiz: QuizChoice;
  onSetQuizAnswer: (quizId: string, answerIndex: number) => void;
  onUpdateQuizChoice: (quizId: string, choiceIndex: number, value: string) => void;
  onRemoveQuizChoice: (quizId: string, choiceIndex: number) => void;
  onAddQuizChoice: (quizId: string) => void;
  allowMultiple?: boolean;
}

const QuizChoiceSection: React.FC<QuizChoiceSectionProps> = ({
  quiz,
  onSetQuizAnswer,
  onUpdateQuizChoice,
  onRemoveQuizChoice,
  onAddQuizChoice,
  allowMultiple = false,
}) => {
  return (
    <Row gutter={24} className='!w-full'>
      <Col span={24}>
        <Form.Item
          label={`보기 (정답 보기를 ${allowMultiple ? '여러 개 선택할 수 있습니다.' : '선택해주세요.'})`}
          required
        >
          {quiz.choices.map((choice, choiceIndex) => (
            <div
              key={choiceIndex}
              className={`flex flex-col gap-2 p-3 mb-2 bg-gray-50 rounded-lg border ${
                (Array.isArray(quiz.answer) 
                  ? quiz.answer.includes(choiceIndex) 
                  : quiz.answer === choiceIndex) 
                  ? 'border-green-500' 
                  : 'border-gray-300'
              }`}
            >
              <div className="flex gap-2 items-center">
                {allowMultiple ? (
                  <Checkbox
                    checked={Array.isArray(quiz.answer) && quiz.answer.includes(choiceIndex)}
                    onChange={() => onSetQuizAnswer(quiz.id, choiceIndex)}
                  />
                ) : (
                <Radio
                  checked={quiz.answer === choiceIndex}
                  onChange={() => onSetQuizAnswer(quiz.id, choiceIndex)}
                />
                )}
                <div className='relative w-full'>
                  <Input
                    placeholder="보기를 입력하세요"
                    size="large"
                    value={choice}
                    onChange={(e) => onUpdateQuizChoice(quiz.id, choiceIndex, e.target.value)}
                    style={{ flex: 1 }}
                  />
                  {(
                    Array.isArray(quiz.answer)
                      ? quiz.answer.includes(choiceIndex)
                      : quiz.answer === choiceIndex
                  ) && (
                    <div className="flex absolute right-0 top-1/2 -translate-y-1/2">
                      <Tag color={allowMultiple ? 'geekblue' : 'green'} style={{ fontSize: '14px', padding: '4px 12px' }}>
                        정답
                      </Tag>
                    </div>
                  )}
                </div>
                {quiz.choices.length > 2 && (
                  <Button
                    type="primary"
                    danger
                    ghost
                    icon={<DeleteOutlined />}
                    size="large"
                    onClick={() => onRemoveQuizChoice(quiz.id, choiceIndex)}
                  >
                    삭제
                  </Button>
                )}
                {choiceIndex === quiz.choices.length - 1 && quiz.choices.length < 5 && (
                  <Button
                    type="primary"
                    size="large"
                    onClick={() => onAddQuizChoice(quiz.id)}
                  >
                    보기추가
                  </Button>
                )}
              </div>
            </div>
          ))}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default QuizChoiceSection; 